var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fertigation single-step"},[_c('FirstSection'),(_vm.tanks.length)?_c('TankDist'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }